<template>
  <v-container fluid pa-0>
    <TibBannerTable />
  </v-container>
</template>

<script>
import TibBannerTable from '@/modules/tibBanner/components/TibBannerTable'

export default {
  name: 'TibBanner',

  components: {
    TibBannerTable
  }
}
</script>
